import { useState, useEffect } from 'react';

export type Settings = {
  mode: string;
  voice: string;
};

const SETTINGS_KEY = 'reflect_settings';

export function useSettings() {
  const [settings, setSettings] = useState<Settings | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  // Load settings from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (stored) {
      try {
        setSettings(JSON.parse(stored));
      } catch {
        setSettings(null);
      }
    }
    setIsLoaded(true);
  }, []);

  const saveSettings = (newSettings: Settings) => {
    setSettings(newSettings);
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(newSettings));
  };

  return { settings, isLoaded, saveSettings };
}

export default useSettings;
